import { mockEnrichmentsFilterQueryOperationQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockEntities = [
  {
    __typename: 'EntityInterface' as const,
    entityTypeName: 'Email',
    id: '_email-rdennis@sumologic.com',
    value: 'rdennis@sumologic.com',
  },
  {
    __typename: 'EntityInterface' as const,
    entityTypeName: 'Username',
    id: '_username-mgarst@proofpointdemo.com',
    value: 'mgarst@proofpointdemo.com',
  },
  {
    __typename: 'EntityInterface' as const,
    entityTypeName: 'foobar',
    id: 'foobar-MESSAGE_BLOCKED',
    value: 'MESSAGE_BLOCKED',
  },
  {
    __typename: 'EntityInterface' as const,
    entityTypeName: 'IP Address',
    id: '_ip-185.203.243.75',
    value: '185.203.243.75',
  },
];

export const handlers = [
  mockEnrichmentsFilterQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entitiesByListIds: mockEntities,
        },
      });
    }
  ),
];

export { mockEnrichmentsFilterQueryOperationQuery };
